<template>
  <v-container>
    <v-layout row wrap></v-layout>
    <iframe
      id="pdf"
      target="_blank"
      frameborder="0"
      style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px"
      height="100%"
      width="100%"
    ></iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapActions } from "vuex";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import SettingService from "@/services/SettingService";
import DocumentService from "@/services/DocumentService";
import { async } from "q";
export default {
  data() {
    return {
      Resultdata:{},
      tmpResult:{},
      branch: "",
      from_date:"",
      to_date:"",
      dep:"",
      companybuilding: "", //อาคาร
      companyroom_no:"", //ห้อง
      companyfloor:"", //ชั้น
      companyvillage:"",//หมู่บ้าน
      companyhouse_no:"",//บ้านเลขที่
      companyvillage_no:"",//หมู่ที่
      companyalley_lane:"",//ตรอก/ซอย
      companyroad:"",//ถนน
      companysubdistrict_subarea:"", //ตำบล/แขวง
      companydistrict_area:"",//อำเภอ/เขต
      companyprovince: "",//จังหวัด
      companypostcode: "",//รหัสไปรษณีย์
      companyName: "",
      taxpayer_number:"",
      person:0,
      totalEarning:0,
      totaldeduct_tax:0
    };
  },
 async created() {
    this.branch = this.$route.params.branch;
    this.from_date = this.$route.params.fromDate;
    this.to_date = this.$route.params.toDate;
   await this.getCompany(); 
   await this.getTax();
   await this.pdf();
   
  },

  methods: {
      groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    async getTax() {
      let branchs = "";
      if(this.branch == "ALL"){
        branchs = "";
         this.Resultdata = await DocumentService.getTaxDetailByMonths(branchs,this.dep,this.from_date,this.to_date);
      }else{
        branchs = this.branch;
         this.Resultdata = await DocumentService.getTaxDetailByMonths(branchs,this.dep,this.from_date,this.to_date);
      }

     
      var total_person = this.groupBy(this.Resultdata.data.details, "emp_code");
      for (var key in total_person) {
         this.person +=1;
      }
      this.totalEarning = this.Resultdata.data.total_earning;
      this.totaldeduct_tax = this.Resultdata.data.total_tax;
    },
    async getCompany() {
      let v = this;
      try {
        this.tmpResult = await SettingService.getDataCompany();
          v.companyName = this.tmpResult.data.content[0].companyname;
          v.companybuilding = this.tmpResult.data.content[0].building; //อาคาร
          v.companyroom_no = this.tmpResult.data.content[0].room_no; //ห้อง
          v.companyfloor = this.tmpResult.data.content[0].floor; //ชั้น
          v.companyvillage = this.tmpResult.data.content[0].village;//หมู่บ้าน
          v.companyhouse_no = this.tmpResult.data.content[0].house_no;//บ้านเลขที่
          v.companyvillage_no = this.tmpResult.data.content[0].village_no;//หมู่ที่
          v.companyalley_lane = this.tmpResult.data.content[0].alley_lane;//ตรอก/ซอย
          v.companyroad = this.tmpResult.data.content[0].road;//ถนน
          v.companysubdistrict_subarea = this.tmpResult.data.content[0].subdistrict_subarea; //ตำบล/แขวง
          v.companydistrict_area = this.tmpResult.data.content[0].district_area;//อำเภอ/เขต
          v.companyprovince = this.tmpResult.data.content[0].province;//จังหวัด
          v.companypostcode = this.tmpResult.data.content[0].postcode;//รหัสไปรษณีย์
          v.taxpayer_number = this.tmpResult.data.content[0].taxpayer_number;
      } catch (err) {
        console.log(err);
      }
    },

    async pdf() {
      const url = "/static/pdf/200360_WHT1.pdf";
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      pdfDoc.registerFontkit(fontkit);
      const urlfont = "/static/Sarabun-Regular.ttf";
      const fontBytes = await fetch(urlfont).then(res => res.arrayBuffer());
      const customFont = await pdfDoc.embedFont(fontBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
      let v = this;
      //เลขประจำตัวผู้เสียภาษีอาการ(13 หลัก)
      if (v.taxpayer_number != null) {
        firstPage.drawText("" + v.taxpayer_number.substring(0, 1), {
          x: 164,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(1, 2), {
          x: 180,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(2, 3), {
          x: 192,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(3, 4), {
          x: 204,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(4, 5), {
          x: 215,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(5, 6), {
          x: 231,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(6, 7), {
          x: 243,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(7, 8), {
          x: 254,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(8, 9), {
          x: 265,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(9, 10), {
          x: 276,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(10, 11), {
          x: 294,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(11, 12), {
          x: 306,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
        firstPage.drawText("" + v.taxpayer_number.substring(12, 13), {
          x: 322,
          y: 738,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0)
        });
      }
      //ชื่อบริษัท
        firstPage.drawText(""+this.companyName, {
          x: 60,
          y: 693 ,
          size: 10,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        //อาคาร
        if(this.companybuilding==''|| this.companybuilding==null){
          firstPage.drawText("-", {x: 110, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companybuilding, {x: 110, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         //ห้องที่
        if(this.companyroom_no ==''|| this.companyroom_no==null){
          firstPage.drawText("-", {x: 195, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyroom_no, {x: 190, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         //ชั้นที่
        if(this.companyfloor ==''|| this.companyfloor==null){
          firstPage.drawText("-", {x: 230, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyfloor, {x: 230, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }

         //หมู่บ้าน
        if(this.companyvillage ==''|| this.companyvillage==null){
          firstPage.drawText("-", {x: 285, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyvillage, {x: 275, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
        
         //ที่อยู่
         if(this.companyhouse_no ==''|| this.companyhouse_no==null){
           firstPage.drawText("-", {x: 80, y: 660 ,size: 10, font: customFont, color: rgb(0, 0, 0),}); 
         }
         else{
           firstPage.drawText(""+this.companyhouse_no, {x: 80, y: 660 ,size: 10, font: customFont, color: rgb(0, 0, 0),}); 
         }
        

       //หมู่ที่
        if(this.companyvillage_no ==''|| this.companyvillage_no==null){
          firstPage.drawText("-", {x: 160, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyvillage_no, {x: 160, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }

         //ตรอก/ซอย
        if(this.companyalley_lane ==''|| this.companyalley_lane==null){
          firstPage.drawText("-", {x: 230, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyalley_lane, {x: 230, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         firstPage.drawText("-", {x: 310, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});

        //ถนน
        if(this.companyroad ==''|| this.companyroad== null){
          firstPage.drawText("-", {x: 80, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyroad, {x: 80, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
        //ตำบล
        if(this.companysubdistrict_subarea ==''|| this.companysubdistrict_subarea== null){
          firstPage.drawText("-", {x: 250,y: 645 ,size: 10, font: customFont, color: rgb(0, 0, 0), });
        }else{
          firstPage.drawText(""+this.companysubdistrict_subarea, {x: 250,y: 645 ,size: 10, font: customFont, color: rgb(0, 0, 0), });
        }
         //อำเภอ
          if(this.companysubdistrict_subarea ==''|| this.companysubdistrict_subarea== null){
            firstPage.drawText("-", { x: 120, y: 628 , size: 10,font: customFont,color: rgb(0, 0, 0),});
          }
          else{
            firstPage.drawText(""+this.companydistrict_area, { x: 120, y: 628 , size: 10,font: customFont,color: rgb(0, 0, 0),});
          }
      
          //เชียงใหม่
        firstPage.drawText(""+this.companyprovince, {x: 250,y: 628 , size: 10,font: customFont,color: rgb(0, 0, 0),});
         //รหัสไปรษณีย์
        firstPage.drawText(""+this.companypostcode.substring(0,1), { x: 94,y: 611 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(1,2), { x: 104,y: 611 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(2,3), { x: 115,y: 611 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(3,4), { x: 126,y: 611 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(4,5), { x: 136,y: 611 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
      //จำนวนผู้เสียภาษี
        firstPage.drawText("" + v.person, {
        x: 342,
        y: 419,
        size: 10,
        font: customFont,
        color: rgb(0, 0, 0)
      });
       //จำนวน เงินทั้งสิ้น
      //   firstPage.drawText("" + this.thousandSep(v.totalEarning), {
      //   x: 405,
      //   y: 420,
      //   size: 10,
      //   font: customFont,
      //   color: rgb(0, 0, 0)
      // });
        //จำนวน เงินทั้งสิ้น
       let totalEarning = this.thousandSep(v.totalEarning).split(".");
      if(totalEarning[0].length >= 13){
         firstPage.drawText(""+  totalEarning[0], { x:(435-(5 * (totalEarning[0].length - 4) )) - totalEarning[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalEarning[0].length < 13 && totalEarning[0].length >= 9){
         firstPage.drawText(""+  totalEarning[0], { x:(435-(5 * (totalEarning[0].length - 3) )) - totalEarning[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalEarning[0].length < 9 && totalEarning[0].length >= 4){
          firstPage.drawText(""+  totalEarning[0], { x:(435-(5 * (totalEarning[0].length - 2) )) - totalEarning[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totalEarning[0], { x:(435-(5 * (totalEarning[0].length - 1) )) - totalEarning[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totalEarning[1],{ x: 440  ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)}); 
        
       //จำนวนภาษีทั้งสิ้น
        let totaldeduct_tax = this.thousandSep(v.totaldeduct_tax).split(".");
      if(totaldeduct_tax[0].length >= 13){
         firstPage.drawText(""+  totaldeduct_tax[0], { x:(522-(5 * (totaldeduct_tax[0].length - 4) )) - totaldeduct_tax[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totaldeduct_tax[0].length < 13 && totaldeduct_tax[0].length >= 9){
         firstPage.drawText(""+  totaldeduct_tax[0], { x:(522-(5 * (totaldeduct_tax[0].length - 3) )) - totaldeduct_tax[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalEarning[0].length < 9 && totaldeduct_tax[0].length >= 4){
          firstPage.drawText(""+  totaldeduct_tax[0], { x:(522-(5 * (totaldeduct_tax[0].length - 2) )) - totaldeduct_tax[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totaldeduct_tax[0], { x:(522-(5 * (totaldeduct_tax[0].length - 1) )) - totaldeduct_tax[0].length ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totaldeduct_tax[1],{ x: 527  ,y: 419,size: 10,font: customFont, color: rgb(0, 0, 0)}); 
      //   firstPage.drawText("" + this.thousandSep(v.totaldeduct_tax), {
      //   x: 505,
      //   y: 420,
      //   size: 10,
      //   font: customFont,
      //   color: rgb(0, 0, 0)
      // });
        firstPage.drawText("" + v.person, {
        x: 342,
        y: 279,
        size: 10,
        font: customFont,
        color: rgb(0, 0, 0)
      });
       //จำนวน เงินทั้งสิ้น
      //   firstPage.drawText("" + this.thousandSep(v.totalEarning), {
      //   x: 405,
      //   y: 420,
      //   size: 10,
      //   font: customFont,
      //   color: rgb(0, 0, 0)
      // });
        //จำนวนรวมเงินทั้งสิ้น
       let totalsumEarning = this.thousandSep(v.totalEarning).split(".");
      if(totalEarning[0].length >= 13){
         firstPage.drawText(""+  totalsumEarning[0], { x:(435-(5 * (totalsumEarning[0].length - 4) )) - totalsumEarning[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumEarning[0].length < 13 && totalEarning[0].length >= 9){
         firstPage.drawText(""+  totalsumEarning[0], { x:(435-(5 * (totalsumEarning[0].length - 3) )) - totalsumEarning[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumEarning[0].length < 9 && totalsumEarning[0].length >= 4){
          firstPage.drawText(""+  totalsumEarning[0], { x:(435-(5 * (totalsumEarning[0].length - 2) )) - totalsumEarning[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totalsumEarning[0], { x:(435-(5 * (totalsumEarning[0].length - 1) )) - totalsumEarning[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totalsumEarning[1],{ x: 440  ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)}); 
        
       //จำนวนรวมภาษีทั้งสิ้น
        let totalsumdeduct_tax = this.thousandSep(v.totaldeduct_tax).split(".");
      if(totalsumdeduct_tax[0].length >= 13){
         firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(522-(5 * (totalsumdeduct_tax[0].length - 4) )) - totalsumdeduct_tax[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumdeduct_tax[0].length < 13 && totalsumdeduct_tax[0].length >= 9){
         firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(522-(5 * (totalsumdeduct_tax[0].length - 3) )) - totalsumdeduct_tax[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumdeduct_tax[0].length < 9 && totalsumdeduct_tax[0].length >= 4){
          firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(522-(5 * (totalsumdeduct_tax[0].length - 2) )) - totalsumdeduct_tax[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(522-(5 * (totalsumdeduct_tax[0].length - 1) )) - totalsumdeduct_tax[0].length ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totalsumdeduct_tax[1],{ x: 527  ,y: 279,size: 10,font: customFont, color: rgb(0, 0, 0)}); 
  //จำนวนรวมภาษีทั้งสิ้น
      let finaltotaldeduct_tax = this.thousandSep(v.totaldeduct_tax).split(".");
      if(totalsumdeduct_tax[0].length >= 13){
         firstPage.drawText(""+  finaltotaldeduct_tax[0], { x:(522-(5 * (finaltotaldeduct_tax[0].length - 4) )) - finaltotaldeduct_tax[0].length ,y: 243,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(finaltotaldeduct_tax[0].length < 13 && finaltotaldeduct_tax[0].length >= 9){
         firstPage.drawText(""+  totafinaltotaldeduct_taxlsumdeduct_tax[0], { x:(522-(5 * (finaltotaldeduct_tax[0].length - 3) )) - finaltotaldeduct_tax[0].length ,y: 243,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(finaltotaldeduct_tax[0].length < 9 && finaltotaldeduct_tax[0].length >= 4){
          firstPage.drawText(""+  finaltotaldeduct_tax[0], { x:(522-(5 * (finaltotaldeduct_tax[0].length - 2) )) - finaltotaldeduct_tax[0].length ,y: 243,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  finaltotaldeduct_tax[0], { x:(522-(5 * (finaltotaldeduct_tax[0].length - 1) )) - finaltotaldeduct_tax[0].length ,y: 243,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ finaltotaldeduct_tax[1],{ x: 527  ,y: 243,size: 10,font: customFont, color: rgb(0, 0, 0)}); 

      const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      document.getElementById("pdf").src = pdfDataUri;
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    }
  }
};
</script>

